export default __webpack_public_path__ + "static/media/ic-blood-pressure-gauge.4c43ab59.svg";